import React, {useCallback, useState} from "react";
import ViewPageLayout from "../../../../../ui/ViewPageLayout";
import DocumentList
  from "../../../../../ManageOOP/Resources/Person/pages/PersonView/components/Documents/Attachments/DocumentList";
import Typography from "@material-ui/core/Typography";

const Documents = ({classes,requestId}) => {
  const [attachments, setAttachments] = useState([]);

  return (<ViewPageLayout header="Документы">
          {(attachments && attachments.length > 0) ?
            <DocumentList files={attachments}/>
            : <Typography color={"textSecondary"}>файлы отсутствуют</Typography>
          }
    </ViewPageLayout>
  )
}

export default Documents;
